import React, { Component } from 'react';

// A component that helps with rendering the side articles of a particular section for the site
class Aside extends Component {
  render() {
    return (
      <div id="article-aside" className="flex-overflow-item">
        <div id="article-aside-lining">
          <div id="article-aside-navbox">
            <a className="aside-a-nav" href="" onClick={this.props.onAsideSection.bind(this, false)}><i className="far fa-caret-square-left"></i></a>
          </div>
          <div id="article-aside-main">
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

export default Aside;


// WEBPACK FOOTER //
// ./src/Aside.js